

const testimonialSlider = new Swiper("#testimonial", {
  loop: true,
  slidesPerView: 1,
  navigation: {
    nextEl: "#testimonial #carousal_next",
    prevEl: "#testimonial #carousal_previous",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 3,
    },
    1400: {
      slidesPerView: 4,
    },
  },
});



